const retrospect = [
  {
    path: 'retrospect/drug-bat-manager',
    name: 'retrospect-drug-bat-manager',
    meta: {
      title: '药品批次管理',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/drug-bat-manager.vue'], resolve)
  },
  {
    path: 'retrospect/material-bat-manager',
    name: 'retrospect-material-bat-manager',
    meta: {
      title: '耗材批次管理',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/material-bat-manager.vue'], resolve)
  },
  {
    path: 'retrospect/outpatient-material',
    name: 'retrospect-outpatient-material',
    meta: {
      title: '门诊耗材分配',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/outpatient-material.vue'], resolve)
  },
  {
    path: 'retrospect/inpatient-material',
    name: 'retrospect-inpatient-material',
    meta: {
      title: '住院耗材分配',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/inpatient-material.vue'], resolve)
  },
  {
    path: 'retrospect/dept-drug-bat-manager',
    name: 'retrospect-dept-drug-bat-manager',
    meta: {
      title: '科室药品批次管理',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/department/drug-bat-manager.vue'], resolve)
  },
  {
    path: 'retrospect/dept-material-bat-manager',
    name: 'retrospect-dept-material-bat-manager',
    meta: {
      title: '科室药品批次管理',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/department/material-bat-manager.vue'], resolve)
  }
]
export default retrospect
